import { userStore } from '@/lib/stores/user.store';
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API,
  timeout: 90000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    config.headers.authorization = `Bearer ${localStorage.getItem('access-token')}`;
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (config) => config,
  async (error) => {
    const original = error.config;
    if (error?.response?.status == 401 && error.config && !error.config._isRetry) {
      original._isRetry = true;
      try {
        const response = await axios.get<{ result: { token: string } }>(
          `${process.env.NEXT_PUBLIC_API}/auth/refresh`,
          { withCredentials: true },
        );
        localStorage.setItem('access-token', response.data.result.token);
        return api.request(original);
      } catch {}
    }
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      userStore.deleteUser();
      userStore.setIsAuth(false);
    }
    throw error;
  },
);

export const useApi = () => ({ api });
